export const DOMAIN = 'consentConfigDetails.tattles';
